import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';
import { AppointmentDTO, AppointmentRequestBodyDTO, BookForSaleDTO, EventsDTO, WatchDTO } from '../models';
import { BookedForSalesRequestBodyDTO } from '../models/booked-for-sales-request-body-dto';
import { BasketCapacityDialogComponent } from 'src/app/components/dialogs/basket-capacity-dialog/basket-capacity-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class ManagementService extends __BaseService {

  static readonly managementPath = '/Management';
  static readonly eventsPath = ManagementService.managementPath + "/events";

  public showAgainBasketCapacityDialog: boolean = true;

  // /Management/
  static appointmentPath(idAppointment: number) {
    // return ManagementService.managementPath + '/' + idAppointment;
    return `/management/Agenda/events/appointments/${idAppointment}`
  }

  static deleteAppointmentPath(id: number) {
    return ManagementService.managementPath + '/' + id;
  }

  static appointmentsPath(idEvent: number) {
    return ManagementService.managementPath + '/list/' + idEvent;
  }

  static exportPath(idEvent: number) {
    // return ManagementService.managementPath + '/export/' + idEvent;
    return `/management/Agenda/events/${idEvent}/appointments/export`;
  }

  static watchesPath(idEvent: number) {
    return `/management/Watches/events/${idEvent}/products`;
    // return ManagementService.managementPath + '/watches/' + idEvent;
  }

  static engravingsPath(idEvent: number, sapCode: string) {
    return `/management/Watches/events/${idEvent}/products/${sapCode}/engravings`;
    // return this.managementPath + '/' + idEvent + '/Engravings/' + sapCode;
  }

  static engravingsWatchesPath(idEvent: number, sapCode: string) {
    return `/management/Watches/events/${idEvent}/products/${sapCode}/engravings`;
    // return this.watchesPath(idEvent) + '/engravings/' + sapCode;
  }

  static discountPath(idSoldToParty: number, sapCode: string) {
    return `/management/Agenda/events/soldtoparty/${idSoldToParty}/discount/${sapCode}`;
    // return this.managementPath + '/' + idSoldToParty + '/Discount/' + sapCode;
  }

  static sellablePath(idEvent: number, sapCode: string) {
    return `/management/Watches/events/${idEvent}/products/${sapCode}/sellable`;
    // return this.watchesPath(idEvent) + '/sellable/' + sapCode;
  }

  static bookedForSalePath(id: number) {
    return `/management/Agenda/events/bookforsale/${id}`;
    // return this.managementPath + '/BookForSale/' + id;
  }

  static bookedForSaleEventPath(id: number) {
    return `/management/Agenda/events/${id}/bookforsale`;
    // return this.managementPath + '/BookForSale/Event/' + id;
  }

  static createBookForSalePath(idEvent: number, sapCode: string) {
    return `/management/Agenda/events/${idEvent}/bookforsale/${sapCode}`;
    // return this.managementPath + "/BookForSale/Event/" + idEvent + "/Product/" + sapCode;
  }

  static submitAgendaPath(idEvent: number) {
    return `/management/Agenda/events/${idEvent}/submit`;
    // return this.managementPath + '/events/' + idEvent + '/submit';
  }

  static updateTimezonePath(idEvent: number) {
    return this.managementPath + '/events/' + idEvent + '/tzoffset';
  }

  static checkInPath(idEvent: number, idAppointment: string) {
    return this.managementPath + '/events/' + idEvent + '/appointments/' + idAppointment + '/checkin';
  }


  constructor(
    config: __Configuration,
    http: HttpClient,
    private readonly dialog: MatDialog
  ) {
    super(config, http);
  }

  /**
   * * GET MANAGEMENT APPOIMNTMENT
   *  /api/Management/Appointment/{id}
   * @param id
   * @returns retrieve appointment
   */
  getAppointmentResponse(id: number): __Observable<__StrictHttpResponse<AppointmentDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + ManagementService.appointmentPath(id),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AppointmentDTO>;
      })
    );
  }
  getAppointment(idEvent: number): __Observable<AppointmentDTO> {
    return this.getAppointmentResponse(idEvent).pipe(
      __map(_r => _r.body as AppointmentDTO)
    );
  }

  /**
   * * GET MANAGEMENT APPOINTMENTS
   * @param idEvent
   * @returns retrieve a list of appointments for a specific Event.
   */
  getAppointmentsResponse(idEvent: number, appointmentDate: string, params?: any): __Observable<__StrictHttpResponse<AppointmentDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (appointmentDate != null) __params = __params.set('AppointmentDate', appointmentDate);

    if (params) {
      if (params.Status !== null && !Number.isNaN(params.Status)) __params = __params.set('Status', params.Status.toString());
      if (params.Search) __params = __params.set('Search', params.Search.toString());
      if (typeof params.HasCheckInDate === "boolean") __params = __params.set('HasCheckInDate', params.HasCheckInDate);
      if (params.Country) {
        params.Country.forEach((country: string) => {
          __params = __params.append('Country', country.toString());
        })
      }
    }

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + ManagementService.appointmentsPath(idEvent),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<AppointmentDTO>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AppointmentDTO>;
      })
    );
  }
  getAppointments(idEvent: number, appointmentDate: string, params?: any): __Observable<AppointmentDTO> {
    return this.getAppointmentsResponse(idEvent, appointmentDate, params).pipe(
      __map(_r => _r.body as AppointmentDTO)
    );
  }

  /**
   * * GET EVENTS
   * @param year optional year for events
   * @returns retrieve all the events (optional: in a specific year)
   */
  getEventsResponse(year?: string): __Observable<__StrictHttpResponse<EventsDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (year != null) __params = __params.set('year', year.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + ManagementService.eventsPath,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<EventsDTO>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<EventsDTO>;
      })
    );
  }
  getEvents(year?: string): __Observable<any> {
    return this.getEventsResponse(year).pipe(
      __map(_r => _r.body as EventsDTO)
    );
  }

  /**
   * * CREATE APPOINTMENT
   * @param requestBody
   * @returns outcome
   */
  postCreateAppointmentResponse(requestBody?: AppointmentRequestBodyDTO): __Observable<__StrictHttpResponse<Boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = requestBody;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/management/Agenda/events/${requestBody?.idEvent}/appointments`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  postCreateAppointment(requestBody?: AppointmentRequestBodyDTO): __Observable<Boolean> {
    return this.postCreateAppointmentResponse(requestBody).pipe(
      __map(_r => _r.body as any)
    );
  }

  /**
   * * DELETE APPOINTMENT
   * @param id appointment to delete
   * @returns delete an appointment
   */
  deleteAppointmentResponse(id: number): __Observable<__StrictHttpResponse<Boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/management/Agenda/events/appointments/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  deleteAppointment(id: number): __Observable<Boolean> {
    return this.deleteAppointmentResponse(id).pipe(
      __map(_r => _r.body as any)
    );
  }

  /**
   * * UPDATE APPOINTMENT
   * @param requestBody
   * @returns update an appointment
   */
  putUpdateAppointmentResponse(requestBody?: AppointmentRequestBodyDTO): __Observable<__StrictHttpResponse<Boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = requestBody;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/management/Agenda/events/${requestBody?.idEvent}/appointments/${requestBody?.id}`,
      // this.rootUrl + ManagementService.managementPath,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  putUpdateAppointment(requestBody?: AppointmentRequestBodyDTO): __Observable<Boolean> {
    return this.putUpdateAppointmentResponse(requestBody).pipe(
      __map(_r => _r.body as any)
    );
  }

  /**
   * EXPORT MANAGEMENT
   * @param idEvent
   * @returns blob file
   */
  getExportResponse(idEvent: number): __Observable<__StrictHttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (idEvent != null) __params = __params.set('idEvent', idEvent.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + ManagementService.exportPath(idEvent),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<EventsDTO>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  getExport(idEvent: number): __Observable<any> {
    return this.getExportResponse(idEvent).pipe(
      __map(_r => _r.body as any)
    );
  }


  /**
 * * GET MANAGEMENT APPOIMNTMENT
 *  /api/bo/Management/watches/{idEvent}
 * @param idEvent
 * @param params
 * @returns retrieve appointment
 */
  getWatchesResponse(idEvent: number, params?: any): __Observable<__StrictHttpResponse<WatchDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params) {
      if (params.Skip) __params = __params.set('Skip', params.Skip.toString());
      if (params.Limit) __params = __params.set('Limit', params.Limit.toString());
      if (params.Search) __params = __params.set('Search', params.Search.toString());
      if (params.OrderBy) __params = __params.set('OrderBy', params.OrderBy.toString());
      if (params.isDesc) __params = __params.set('isDesc', params.isDesc.toString());
    }

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + ManagementService.watchesPath(idEvent),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<WatchDTO>;
      })
    );
  }
  getWatches(idEvent: number, params?: any): __Observable<WatchDTO> {
    return this.getWatchesResponse(idEvent, params).pipe(
      __map(_r => _r.body as WatchDTO)
    );
  }

  /**
 * * PUT MANAGEMENT WATCH ENGRAVINGS
 *  /api/bo/Management/watches/{idEvent}/engravings/{sapCode}
 * @param idEvent
 * @param sapCode
 * @param engravings
 * @returns update field engraving
 */
  updateEngravingsResponse(idEvent: number, sapCode: string, engravings?: string): __Observable<__StrictHttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = {
      engravings: engravings && engravings !== '' ? engravings : ''
    }

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + ManagementService.engravingsWatchesPath(idEvent, sapCode),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  updateEngravings(idEvent: number, sapCode: string, engravings?: string): __Observable<any> {
    return this.updateEngravingsResponse(idEvent, sapCode, engravings).pipe(
      __map(_r => _r.body as any)
    );
  }




  /**
* * PUT MANAGEMENT WATCH ENGRAVINGS
*  /api/bo/Management/watches/{idEvent}/engravings/{sapCode}
* @param idEvent
* @param sapCode
* @param engravings
* @returns update field engraving
*/
  updateSellableResponse(idEvent: number, sapCode: string): __Observable<__StrictHttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + ManagementService.sellablePath(idEvent, sapCode),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  updateSellable(idEvent: number, sapCode: string): __Observable<any> {
    return this.updateSellableResponse(idEvent, sapCode).pipe(
      __map(_r => _r.body as any)
    );
  }

  /**
* * GET MANAGEMENT BOOK FOR SALES
*  /api/bo/Management/BookForSale/{idEvent}
* @param idEvent
* @param params
* @returns retrieve booked for sales
*/
  getBookedForSalesResponse(idEvent: number, params?: any): __Observable<__StrictHttpResponse<BookForSaleDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params) {
      if (params.Skip) __params = __params.set('Skip', params.Skip.toString());
      if (params.Limit) __params = __params.set('Limit', params.Limit.toString());
      if (params.Search) __params = __params.set('Search', params.Search.toString());
      if (params.OrderBy) __params = __params.set('OrderBy', params.OrderBy.toString());
      if (params.isDesc) __params = __params.set('isDesc', params.isDesc.toString());
    }

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + ManagementService.bookedForSaleEventPath(idEvent),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BookForSaleDTO>;
      })
    );
  }
  getBookedForSales(idEvent: number, params?: any): __Observable<BookForSaleDTO> {
    return this.getBookedForSalesResponse(idEvent, params).pipe(
      __map(_r => _r.body as BookForSaleDTO)
    );
  }

  /**
  * * CREATE APPOINTMENT
  * @param requestBody
  * @returns outcome
  */
  postCreateBookForSaleResponse(idEvent: number, sapCode: string, requestBody?: BookedForSalesRequestBodyDTO): __Observable<__StrictHttpResponse<Boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = requestBody;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + ManagementService.createBookForSalePath(idEvent, sapCode),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  postCreateBookForSale(idEvent: number, sapCode: string, requestBody?: BookedForSalesRequestBodyDTO): __Observable<Boolean> {
    return this.postCreateBookForSaleResponse(idEvent, sapCode, requestBody).pipe(
      __map(_r => _r.body as any)
    );
  }

  /**
* * DELETE ITEM FROM ALLOCATION
* @param id appointment to delete
* @returns delete item from allocation
*/
  deleteBookedForSalesResponse(id: number): __Observable<__StrictHttpResponse<Boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + ManagementService.bookedForSalePath(id),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  deleteBookedForSales(id: number): __Observable<Boolean> {
    return this.deleteBookedForSalesResponse(id).pipe(
      __map(_r => _r.body as any)
    );
  }

  /**
 * * SUBMIT AGENDA
 * @param idEvent
 * @returns submit agenda
 */
  submitAgendaResponse(idEvent: number): __Observable<__StrictHttpResponse<Boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + ManagementService.submitAgendaPath(idEvent),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  submitAgenda(idEvent: number): __Observable<Boolean> {
    return this.submitAgendaResponse(idEvent).pipe(
      __map(_r => _r.body as any)
    );
  }

  /**
 * * SUBMIT AGENDA
 * @param idEvent
 * @param tzid
 * @returns submit agenda
 */
  updateTimezponeResponse(idEvent: number, tzid: string): __Observable<__StrictHttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = { timeZoneId: tzid };
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + ManagementService.updateTimezonePath(idEvent),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });
    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  updateTimezone(idEvent: number, tzid: string): __Observable<any> {
    return this.updateTimezponeResponse(idEvent, tzid).pipe(
      __map(_r => _r.body as any)
    );
  }

  /**
 * * SUBMIT CHECKIN
 * @param idEvent
 * @param idAppointment
 * @returns checkin dell'appuntamento
 */
  checkInResponse(idEvent: number, idAppointment: string): __Observable<__StrictHttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + ManagementService.checkInPath(idEvent, idAppointment),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });
    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  checkIn(idEvent: number, idAppointment: string): __Observable<any> {
    return this.checkInResponse(idEvent, idAppointment).pipe(
      __map(_r => _r.body as any)
    );
  }

  /**
   * Get all engravings of a specific product in an event
   * @param idEvent
   * @param sapCode
   * @returns Get all engravings of a specific product in an event
   */
  getEngravingsResponse(idEvent: number, sapCode: string): __Observable<__StrictHttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + ManagementService.engravingsPath(idEvent, sapCode),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  getEngravings(idEvent: number, sapCode: string): __Observable<any> {
    return this.getEngravingsResponse(idEvent, sapCode).pipe(
      __map(_r => _r.body as any)
    );
  }

  /**
   * Get discount for BP event and specific sold to party
   * @param idSoldToParty
   * @param sapCode
   * @returns Get discount for BP event and specific sold to party (an integer)
   */
  getDiscountResponse(idSoldToParty: number, sapCode: string): __Observable<__StrictHttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + ManagementService.discountPath(idSoldToParty, sapCode),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  getDiscount(idSoldToParty: number, sapCode: string): __Observable<any> {
    return this.getDiscountResponse(idSoldToParty, sapCode).pipe(
      __map(_r => _r.body as any)
    );
  }

  showBasketCapacityNotice() {
    if (this.showAgainBasketCapacityDialog) {
      const dialogRef = this.dialog.open(BasketCapacityDialogComponent,
        {
          data: {
            isHjCreations: true,
            // isHeWatches: false
          },
          hasBackdrop: true,
          panelClass: ['basket-capacity-dialog'],
          backdropClass: 'bdrop'
        }
      );
      dialogRef.afterClosed().subscribe((success: any) => {
        if (success) {
          this.showAgainBasketCapacityDialog = false;
        }
      })
    }
  }


}



